import React from 'react';
import { CheckCircleOutlined, CalendarOutlined } from '@ant-design/icons';
import './PaymentStatusIcon.less';
import { useTheme } from '@material-ui/core';

export type PaymentStatus = 'completed' | 'scheduled';

interface PaymentStatusIconProps {
  status: PaymentStatus;
  size?: number;
  color?: string;
  className?: string;
  title?: string;
}

const PaymentStatusIcon = (props: PaymentStatusIconProps) => {
  const { status, size = 48, color, className } = props;
  const theme = useTheme();

  const containerClass = `payment-status-icon ${className || ''}`;
  const iconClass = 'payment-status-icon__icon';
  const iconStyle = color ? { color } : { color: theme.palette?.primary.main };
  const customSizeStyle = size !== 48 ? { fontSize: size } : undefined;
  const finalIconStyle = { ...iconStyle, ...customSizeStyle };

  return (
    <span className={containerClass}>
      {status === 'completed' ? (
        <CheckCircleOutlined className={iconClass} style={finalIconStyle} />
      ) : (
        <CalendarOutlined className={iconClass} style={finalIconStyle} />
      )}
    </span>
  );
};

export default PaymentStatusIcon;
